import { hexToRgb } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { colorStagingBannerBackground } from '../../shared/style-settings'

export const useStagingBannerStyles = makeStyles((theme: Theme) =>
  createStyles({
    stagingBanner: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      background: hexToRgb(colorStagingBannerBackground),
      maxWidth: '100%',
      height: 25,
    },
    stagingBannerElement: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: 25,
    },
    textColorWhite: {
      color: theme.palette.common.white,
      textShadow: '0.5px 0.5px black',
      fontSize: '15px',
    },
  })
)
